import React, { useContext, useEffect, useState, useMemo } from "react";
import "./accountCategories.css";
import { CombinedContext } from "../../../context/combinedContext";
import translations from "../../../translations/translations";
import companyBasedRequest from "../../../request/companyBasedRequest";
import CATEGORY_OPTIONS from "../../../constants/categoryOptions";

const AccountCategories = () => {
	const { language, userData, setUserData } = useContext(CombinedContext);

	const role = userData?.user?.role;
	const accessToken = userData?.cognitoTokens?.AccessToken;
	const shop = userData?.shop;

	const [category, setCategory] = useState("");
	const [subCategory, setSubCategory] = useState("");
	const [saving, setSaving] = useState(false);

	/* ----------------------------
	   DERIVED CATEGORY OBJECT
	----------------------------- */
	const selectedCategory = useMemo(
		() => CATEGORY_OPTIONS.find((c) => c.value === category),
		[category]
	);

	/* ----------------------------
	   LOAD CURRENT VALUES
	----------------------------- */
	useEffect(() => {
		if (!shop) return;

		setCategory(shop.category || "");
		setSubCategory(shop.subCategory || "");
	}, [shop]);

	/* ----------------------------
	   SAVE HANDLER
	----------------------------- */
	const saveCategory = async () => {
		if (!category || !subCategory) return;
		try {
			setSaving(true);

			const resp = await companyBasedRequest.updateShopCategory(
				shop.shopId,
				category,
				subCategory,
				accessToken
			);

			// 🔑 update shop INSIDE userData
			setUserData((prev) => ({
				...prev,
				shop: resp.shop,
			}));
		} catch (err) {
			console.error("Failed to update category", err);
		} finally {
			setSaving(false);
		}
	};

	/* ----------------------------
	   GUARDS
	----------------------------- */
	// if (!shop ) return null;

	return (
		<div className="sf-account-categories-page">
			<h2 className="sf-account-categories-title">
				{translations[language].account.categories.title}
			</h2>

			{/* ───── CATEGORY ───── */}
			<div className="sf-category-block">
				<label className="sf-category-label">
					{translations[language].account.categories.category}
				</label>

				<select
					className="sf-category-select"
					value={category}
					onChange={(e) => {
						setCategory(e.target.value);
						setSubCategory("");
					}}
				>
					<option value="" disabled>
						{translations[language].account.categories.select}
					</option>

					{CATEGORY_OPTIONS.map((cat) => (
						<option key={cat.value} value={cat.value}>
							{language === "es" ? cat.labelES : cat.labelEN}
						</option>
					))}
				</select>
			</div>

			{/* ───── SUB CATEGORY ───── */}
			{selectedCategory && (
				<div className="sf-category-block">
					<label className="sf-category-label">
						{translations[language].account.categories.subCategory}
					</label>

					<select
						className="sf-category-select"
						value={subCategory}
						onChange={(e) => setSubCategory(e.target.value)}
					>
						<option value="" disabled>
							{translations[language].account.categories.select}
						</option>

						{selectedCategory.subCategories.map((sub) => (
							<option key={sub.value} value={sub.value}>
								{language === "es" ? sub.labelES : sub.labelEN}
							</option>
						))}
					</select>
				</div>
			)}

			{/* ───── SAVE BUTTON ───── */}
			<button
				className="sf-category-save-btn"
				onClick={saveCategory}
				disabled={saving || !category || !subCategory}
			>
				{saving
                    ? translations[language].account.categories.saving
                    : translations[language].account.categories.save}

			</button>
		</div>
	);
};

export default AccountCategories;
